//styling
import '../app/App.css';
import 'typeface-lato';

//components
import { Suspense, lazy } from "react";
import Footer from "../components/footer.js";
const TeamMembers = lazy(() => import('../components/team-members.js'));

const About = () => {
    return (
        <div className="centered" style={{backgroundColor: "#FFFBF3" , height: "100%"}}>
            <h1 className="header-text"><br />Our Story</h1>
            
            <div className="body-section">
                <p className="body-text">
                    Foodscape. Inc was founded by Peter Chung, who has always believed in the power of local entrepreneurs. 
                    The project began with a simple idea: using technology to breathe new life into community spaces, 
                    starting with the boba shops he loved.<br /><br />
                    As he set out to support community businesses, he partnered with Kenneth and Reed. Blending thoughtful 
                    tools with genuine care, the team began developing mobile and vending solutions tailored to the needs 
                    of hardworking local owners. As the idea gained momentum, Wharton’s Venture Lab took notice, helping 
                    turn their vision into a growing venture.<br /><br />
                    Today, Foodscape is more than just a company; it’s a growing effort to create new opportunities and 
                    brighter futures for local businesses.
                </p>
            </div>

            <div className="body-section">
                <h1 className="header-text">Meet the Team</h1>
                <Suspense fallback={<div>Loading...</div>}>
                    <TeamMembers />
                </Suspense>
            </div>

            {<Footer />}
        </div>
    )
}

export default About;